export default "__VITE_ASSET__b6b8f004__"